import React            from 'react';
import { makeStyles, Theme } from '../../utility/styles';
import classNames            from 'classnames';

const styles = (_theme: Theme) => ({
  suggestionContainer: { display: 'flex', minWidth: 716, maxWidth: 716 },
  small:               { width: '8% !important' },
  suggestion:          { flexGrow: 1, marginRight: 8, width: '30%', overflow: 'hidden', textOverflow: 'ellipsis' },
  headerContainer:     { display: 'flex', minWidth: 748, maxWidth: 748, padding: '0px 16px', margin: 0, transform: 'translate(0, 8px)' },
  header:              { fontWeight: 'bold', flexGrow: 1, marginRight: 8, width: '30%', overflow: 'hidden', textOverflow: 'ellipsis' },
  emphasis:            { fontWeight: 'bold' },
  center:              { alignItems: 'center', justifyContent: 'center', display: 'flex', fontSize: 14 }
});

const useStyles = makeStyles(styles);


export function renderOccupationSuggestion({ suggestion }: any) {
  const cls = useStyles();
  if (!suggestion || !suggestion?.name) return null;
  const isQualified  = suggestion.isQualified ? '🗹' : (suggestion.isQualified === false) ? '☐' : '-';
  return <div className={cls.suggestionContainer}>
    <div title={suggestion.code}            className={classNames(cls.small, cls.suggestion, cls.emphasis)}>{suggestion.code}</div>
    <div title={suggestion.name}            className={classNames(cls.suggestion, cls.emphasis)}>{suggestion.name}</div>
    <div title={suggestion.generator?.name} className={classNames(cls.suggestion)}>{suggestion.generator?.name}</div>
    <div title={suggestion.employee?.name}  className={classNames(cls.suggestion)}>{suggestion.employee?.name}</div>
    <div                                    className={classNames(cls.suggestion, cls.emphasis, cls.center, cls.small)}><span>{isQualified}</span></div>
  </div>;
}

export function renderOccupationSuggestionHeader() {
  const cls = useStyles();
  return <div className={cls.headerContainer}>
    <div className={classNames(cls.small, cls.header)}>Code</div>
    <div className={cls.header}>Name</div>
    <div className={cls.header}>Shift Pattern</div>
    <div className={cls.header}>Assigned Employee</div>
    <div className={classNames(cls.header, cls.small)}>Qualified</div>
  </div>;
}
